import axios from "../axios"

const userApi = {
	getUserCompany() { //获取当前账号企业基本信息
		return axios({
			url: `/api/Company/GetUserCompany`,
			method: "post",
		})
	},

	getShowByBaseCompanyId(id) { //根据id获取企业基本信息
		return axios({
			// url: `/api/Company/GetShowByBaseCompanyId`,
			url: `/api/Company/GetEditByBaseCompanyId`,
			method: "post",
			params: {
				id
			}
		})
	},

	saveCompany(data) { //编辑企业信息
		return axios({
			url: `/api/Company/SaveCompany`,
			method: "post",
			data
		})
	},

	getManageToolMenu() { //查询行政区域
		return axios({
			url: `/api/Region/GetManageToolMenu`,
			method: "post",
		})
	},

	getRegionChildern(id) { //查询行政区域byId
		return axios({
			url: `/api/Region/GetChildern`,
			method: "post",
			params: {
				id
			}
		})
	},

	getRegionSheng() { //查询直辖市
		return axios({
			url: `/api/Region/GetSheng`,
			method: "post",
		})
	},

	getregionFullNameStr(id) { //查询行政区域fullname
		return axios({
			url: `/api/Region/GetFullNameStr`,
			method: "post",
			params: {
				id
			}
		})
	},
	getregionStreet(xian) { //查询街道
		return axios({
			url: `/api/Region/QueryRegionLoadList`,
			method: "post",
			params: {
				xian
			}
		})
	},

	saveRegion(data) { //保存行政区域
		return axios({
			url: `/api/Region/CreateAndUpdateSave`,
			method: "post",
			data
		})
	},

	deleteRegion(id) { //删除行政区域
		return axios({
			url: `/api/Region/Delete`,
			method: "post",
			params: {
				id
			}
		})
	},


	uploadFile(path,secondPath,fileName, formData) {
		return axios({
			url: `/file`,
			method: "post",
			params: {
				path,secondPath,fileName
			},
			data: formData
		})
	},

	searchIndustryCategory(id) { //根据父级id查询行业
		return axios({
			url: `/api/BIndustryCategory/Search`,
			method: "post",
			params: {
				id
			}
		})
	},

	saveCategory(data) { //保存行业
		return axios({
			url: `/api/BIndustryCategory/CreateAndUpdateSave`,
			method: "post",
			data
		})
	},

	deleteCategory(id) { //删除行业
		return axios({
			url: `/api/BIndustryCategory/Delete`,
			method: "post",
			params: {
				id
			}
		})
	},

	getIndustryTree() { //查询行业
		return axios({
			url: `/api/BIndustryCategory/GetIndustryTree`,
			method: "post",
		})
	},

	queryForOpen(data) { //查询所有公开
		return axios({
			url: `/api/YearsInfo/QueryForOpen`,
			method: "post",
			data
		})
	},

	getEditById(infoId) {
		return axios({
			url: `api/YearsInfo/GetEditById`,
			method: "post",
			params: {
				infoId
			}
		})
	},

	queryCompanyAppraise(data) { //结果公布
		return axios({
			url: `/api/CompanyAppraise/QueryByParam`,
			method: "post",
			data
		})
	},

	queryECAAppraise(data) { //结果公示
		return axios({
			url: `/api/ECAAppraise/Query`,
			method: "post",
			data
		})
	},
	
	companyQuery(data) { //企业基本信息筛选
		return axios({
			url: `/api/Company/CompanyQuery`,
			method: "post",
			data
		})
	},
	baseCompanyQuery(data) { //企业基本信息筛选
		return axios({
			url: `/api/Company/BaseCompanyQuery`,
			method: "post",
			data
		})
	},
}
export default userApi
